module.exports = __webpack_public_path__ + "media/images/flags/4x3/nam-e335bb35e497aaf0dbe840c14fc034ef.svg";